export enum ResourceType {
  UserGetCurrentUser = 'userGetCurrentUser',
  LoadSites = 'loadSites',
  AddSite = 'addSite',
  GetSite = 'getSite',
  UpdateSite = 'updateSite',
  LoadWorkCenters = 'loadWorkCenters',
  AddWorkCenter = 'addWorkCenter',
  UpdateWorkCenter = 'updateWorkCenter',
  LoadAllUsers = 'loadAllUsers',
  LoadSettings = 'loadSettings',
  LoadMipsComments = 'loadMipsComments',
  LoadMipsComment = 'loadMipsComment',
  AddUser = 'addUser',
  LoadWorkOrder = 'loadWorkOrder',
  LoadWorkOrderOperations = 'loadWorkOrderOperations',
  UpdateWorkLineProgress = 'updateWorkLineProgress',
  UpdateWorkLineQuantity = 'updateWorkLineQuantity',
  UpdateWorkLineCableLength = 'updateWorkLineCableLength',
  LoadUserDetails = 'loadUserDetails',
  SaveUser = 'saveUser',
  LoadWorkOrderDocuments = 'loadWorkOrderDocuments',
}
